// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getOpenBidDetails, GetOpenBidDetailsApiParameter } from "@steiner/App/Services/OpenBidsService";
import { OpenBidOrderModel } from "@steiner/App/Store/Reducers/xOpenBids";

type HandlerType = ApiHandler<GetOpenBidDetailsApiParameter & HasOnSuccess, OpenBidOrderModel>;

export const DispatchSetOpenBidDetailsOrderNumber: HandlerType = props => {
    props.dispatch({
        type: "xOpenBidDetails/SetOpenBidDetailsOrderNumber",
        erpOrderNumber: `${props.parameter.orderNumber}.${props.parameter.generationId}`,
    } as any);
};

export const DispatchBeginLoadOpenBidDetails: HandlerType = props => {
    props.dispatch({
        type: "xOpenBidDetails/BeginLoadingOpenBidDetails",
        isLoading: true,
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getOpenBidDetails(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xOpenBidDetails/FailedLoadingOpenBidDetails",
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadOpenBidDetails: HandlerType = props => {
    props.dispatch({
        type: "xOpenBidDetails/CompleteLoadingOpenBidDetails",
        value: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchSetOpenBidDetailsOrderNumber,
    DispatchBeginLoadOpenBidDetails,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadOpenBidDetails,
    ExecuteOnSuccessCallback,
];

const loadOpenBidDetails = createHandlerChainRunner(chain, "loadOpenBidDetails");

export default loadOpenBidDetails;
